import * as React from 'react'

function SvgComponent(props) {
	return (
		<svg
			width={30}
			height={30}
			viewBox='0 0 30 30'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<path
				d='M15 1.875c-7.248 0-13.125 6.03-13.125 13.459 0 5.947 3.762 10.986 8.977 12.768.073.015.147.023.222.023.486 0 .674-.357.674-.668 0-.322-.012-1.166-.018-2.291a5.995 5.995 0 01-1.324.158c-2.525 0-3.1-1.963-3.1-1.963-.597-1.552-1.458-1.968-1.458-1.968-1.143-.803-.006-.827.082-.827h.006c1.318.118 2.01 1.395 2.01 1.395.656 1.148 1.534 1.47 2.32 1.47a3.69 3.69 0 001.5-.35c.117-.868.457-1.46.832-1.8-2.912-.34-5.977-1.494-5.977-6.65 0-1.47.51-2.672 1.348-3.61-.135-.34-.586-1.71.129-3.562.096-.023.194-.033.293-.03.474 0 1.546.182 3.316 1.413a12.2 12.2 0 016.574 0c1.77-1.23 2.842-1.412 3.317-1.412.098-.004.197.006.293.029.715 1.852.263 3.223.129 3.563.837.943 1.347 2.144 1.347 3.609 0 5.168-3.07 6.305-5.994 6.639.469.416.89 1.236.89 2.49 0 1.799-.017 3.252-.017 3.691 0 .317.182.674.668.674.079 0 .157-.008.234-.023 5.221-1.782 8.977-6.827 8.977-12.768 0-7.43-5.877-13.459-13.125-13.459z'
				fill='#f9f9f9'
			/>
		</svg>
	)
}

export default SvgComponent
